import React, { Component } from 'react';
import _ from 'lodash';
import ErrorImageDialog from 'MyAccount/AssetManager/ImageManager/dialogs/ErrorImageDialog';
import { store } from 'App/store';

export default class ErrorImageDialogWrapper extends Component {

  render() {
    const { open, panelProps, onRequestClose } = this.props;
    return (
      <ErrorImageDialog
        open={open}
        errorMessage={_.get(panelProps, 'errorMessage')}
        closeDialog={onRequestClose}
        onSubmit={_.get(panelProps, 'onSubmit')}
      />
    );
  }
}
